export const FEEDBACK_TYPES = [
    'BUG',
    'FEATURE_REQUEST',
    'IMPROVEMENT',
    'USABILITY',
    'DATA_ISSUE',
    'PERFORMANCE',
    'QUESTION',
    'OTHER',
];
export const FEEDBACK_URGENCIES = ['LOW', 'NORMAL', 'HIGH', 'BLOCKING'];
export const FEEDBACK_REPRODUCIBILITY = ['ALWAYS', 'SOMETIMES', 'ONCE', 'NOT_TRIED'];
export const FEEDBACK_STATUSES = [
    'SUBMITTED',
    'TRIAGED',
    'IN_PROGRESS',
    'RESOLVED',
    'CLOSED',
];
export const FEEDBACK_PRIORITIES = ['LOW', 'MEDIUM', 'HIGH', 'CRITICAL'];
export const FEEDBACK_DIAGNOSTIC_SECTIONS = [
    'APPLICATION',
    'PAGE',
    'BROWSER',
    'BREADCRUMBS',
];
export const FEEDBACK_BREADCRUMB_TYPES = [
    'NAVIGATION',
    'TAB',
    'DIALOG',
    'SAVE',
    'FILTER',
    'SORT',
    'PAGINATION',
    'ACTION',
    'API_ERROR',
    'VALIDATION_ERROR',
    'TOAST_ERROR',
    'ERROR_BOUNDARY',
];
export const FEEDBACK_BREADCRUMB_RESULTS = ['SUCCESS', 'FAILED', 'CANCELLED'];
export const FEEDBACK_MAX_SCREENSHOT_BYTES = 8 * 1024 * 1024;
export const FEEDBACK_MAX_BREADCRUMBS = 25;
export const FEEDBACK_REFERENCE_PATTERN = /^FB-[0-9A-F]{6,12}$/u;
//# sourceMappingURL=feedback.js.map